import classNames from "classnames/bind";
import styles from './Config.module.css';
import { useEffect, useState } from "react";
import { Button, Loading, Toast } from "../../../../../components";
import { useContext } from "react";
import { SettingAIContext } from "../../../../../contexts";
import { aiConfigService } from "../../../../../services/api/aiConfigService";
import { objectCamUniALPR } from "../source";
import { useTranslation } from "react-i18next";
import { licensePlateUniview } from "../../../../../services/api/lisencePlateUniview";

const cx = classNames.bind(styles);

function ConfigObjectCamUni() {
    const { permissionChange, onClose, cameraCode, reGetData, setReGetData, nameService, typeCamera, codeService, showReload, setShowReload } = useContext(SettingAIContext);
    const [isLoading, setIsLoading] = useState(false);
    const [valueConfig, setValueConfig] = useState({});
    const { t } = useTranslation()

    const onChangeStatus = (key, check) => {
        setShowReload(true)
        setValueConfig(pre => ({ ...pre, [key]: check }));
    }

    const getObjectCameraUniALPR = async () => {
        try {
            const param = {
                camera_code: cameraCode
            }
            const res = await licensePlateUniview.getObject(param);
            if (res) {
                setValueConfig(res);
            }
        } catch (error) {
            console.log(error);
        }
    }

    const handleSaveConfig = async () => {
        setIsLoading(true);
        try {
            const info = {
                pedestrian: valueConfig?.pedestrian ? '1' : "0",
                non_motor: valueConfig?.non_motor ? "1" : "0",
                motorcycle: valueConfig?.motorcycle ? "1" : "0",
                motor_vehicle: valueConfig?.motor_vehicle ? "1" : "0"
            }
            const params = {
                camera_code: cameraCode
            }
            await licensePlateUniview.putChangeObject(info, params);
            Toast.open(`Cài đặt ${nameService} thành công`, 'success')
            setIsLoading(false)
        } catch (error) {
            Toast.open(`Cài đặt ${nameService} không thành công`, 'danger')
            setIsLoading(false)
        }
    }

    const handleRefresh = async () => {
        setIsLoading(true)
        try {

        } catch (error) {
            Toast.open(`Cài lại mặc định ${nameService} không thành công`, 'danger');
            setIsLoading(false)
        }
    }

    useEffect(() => {
        // init
        const getData = async () => {
            setIsLoading(true);
            if (nameService.toLowerCase() === 'nhận dạng biển số xe') {
                await getObjectCameraUniALPR();
            }
            setIsLoading(false);
        }
        getData()
    }, [reGetData, nameService])

    const handleCancel = () => {
        // onClose()
        setReGetData(!reGetData);
    }
    return (
        <div className={cx('wrapper-object')}>
            <div className={cx('list-item-object')}>
                {objectCamUniALPR.length > 0 && objectCamUniALPR?.map((item) => {
                    return (
                        <div className={cx('item')} key={item.key}>
                            <input
                                className={cx('input-name')}
                                name={'check-common'}
                                checked={valueConfig[item.key]}
                                type="checkbox"
                                onChange={(e) => onChangeStatus(item.key, e.target.checked)}
                            />
                            <label
                                className={cx('label')}
                                htmlFor={'check-common'}
                                onClick={() => onChangeStatus(item.key, valueConfig[item.key])}
                            >
                                {item.label}
                            </label>
                        </div>
                    )
                })}
            </div>
            {isLoading && <div className={cx('loading-object')}><Loading /></div>}
            {permissionChange && (
                <div className={cx("actions-setting")}>
                    <Button
                        onClick={handleRefresh}
                        className={cx("btn-save")}
                        title={t('setting.Reset_to_default')}
                    />
                    {
                        showReload && <Button className={cx("btn-cancle")} title={t('cameraControl.Cancel')} onClick={handleCancel} />
                    }
                    <Button
                        onClick={() => handleSaveConfig()}
                        className={cx("btn-save")}
                        title={t('settingCam.Save_settings')}
                    />
                </div>
            )}
        </div>
    )
}

export default ConfigObjectCamUni;